// Actions
export const EMPLOYEES_FETCH = "[Employees] Fetch";

// Mutations
export const EMPLOYEES_META = "[Employees] meta";
export const EMPLOYEES_OBTAIN = "[Employees] obtain";
export const EMPLOYEES_CLEAR = "[Employees] clear";
export const EMPLOYEES_SET_LOADING = "[Employees] set loading";
